(()=>{
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
  const root=document.getElementById(("YurchakReviews-" + __shopifySectionId + ""));
  if(!root)return;

  const playVideo=(video)=>{
    if(document.hidden)return;
    const attempt=video.play();
    if(attempt&&typeof attempt.catch==='function')attempt.catch(()=>{});
  };

  const initVideos=()=>{
    root.querySelectorAll('.yreviews__video').forEach((video)=>{
      video.muted=true;
      video.defaultMuted=true;
      video.loop=true;
      video.playsInline=true;
      video.setAttribute('muted','');
      video.setAttribute('loop','');
      video.setAttribute('playsinline','');
      video.setAttribute('autoplay','');
      if(video.dataset.yreviewsInitialized!=='true'){
        video.dataset.yreviewsInitialized='true';
        video.addEventListener('loadeddata',()=>playVideo(video));
        video.addEventListener('canplay',()=>playVideo(video));
        video.addEventListener('ended',()=>{video.currentTime=0;playVideo(video)});
      }
      playVideo(video);
    });
  };

  initVideos();
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)initVideos()});
  root.addEventListener('pointerdown',initVideos,{passive:true});

  const track=root.querySelector('[data-review-slider]'),dots=[...root.querySelectorAll('.yreviews__dots i')];
  if(!track||!dots.length)return;
  let raf;
  const update=()=>{if(innerWidth>989)return;const slides=[...track.querySelectorAll('[data-review-slide]')],left=track.getBoundingClientRect().left;let best=0,dist=Infinity;slides.forEach((s,i)=>{const d=Math.abs(s.getBoundingClientRect().left-left);if(d<dist){dist=d;best=i}});dots.forEach((d,i)=>d.classList.toggle('is-active',i===best))};
  track.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(update)},{passive:true});
  update();
})();
